export default __webpack_public_path__ + "static/media/more-equal.9c78a17c.svg";